import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-container px-container"
}
const _hoisted_2 = { class: "\n          absolute\n          h-auto\n          w-full\n          bg-gradient-to-t\n          from-black\n          to-transparent\n        " }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "absolute w-full h-full top-0 bottom-0 bg-black opacity-50" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "absolute w-full h-full top-0 bottom-0 bg-navy-fade-top" }, null, -1)
const _hoisted_5 = { class: "relative pb-8 lg:pb-16 xl:pb-32" }
const _hoisted_6 = {
  key: 0,
  class: "pt-6"
}
const _hoisted_7 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_8 = { class: "text-xl font-light mb-2 capitalize" }
const _hoisted_9 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_10 = {
  key: 3,
  class: "text-xl font-light mb-6"
}
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-10 text-md font-light" }
const _hoisted_13 = { class: "mb-8 block md:flex justify-between items-center w-full" }
const _hoisted_14 = {
  key: 4,
  class: "text-2xl mb-8"
}
const _hoisted_15 = { class: "grid grip-cols-1 md:grid-cols-2 gap-y-10 md:gap-x-20" }
const _hoisted_16 = { class: "font-light text-lg" }
const _hoisted_17 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 gap-x-10"
}
const _hoisted_18 = { class: "font-light self-end" }
const _hoisted_19 = { class: "text-sm text-amff-gray" }
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = { class: "text-sm text-amff-gray mt-5 md:mt-10" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = {
  key: 0,
  class: "font-light self-end mt-5 md:mt-0"
}
const _hoisted_24 = { class: "text-sm text-amff-gray" }
const _hoisted_25 = { class: "text-sm" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "\n            relative\n            border-b border-amff-light-pink border-opacity-25\n            my-20\n          " }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "max-w-container px-container mb-10"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "text-3xl mb-2 font-bold" }
const _hoisted_30 = { class: "\n                py-6\n                grid grid-cols-1\n                sm:grid-cols-1\n                md:grid-cols-2\n                lg:grid-cols-3\n                gap-y-14 gap-x-7\n              " }
const _hoisted_31 = {
  key: 1,
  class: "max-w-container px-container"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "text-3xl mb-2 font-bold" }
const _hoisted_34 = { class: "\n                py-6\n                grid grid-cols-1\n                sm:grid-cols-1\n                md:grid-cols-2\n                lg:grid-cols-3\n                gap-y-14 gap-x-7\n              " }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_EventImage = _resolveComponent("EventImage")
  const _component_BackgroundVideo = _resolveComponent("BackgroundVideo")
  const _component_Label = _resolveComponent("Label")
  const _component_LocationIcon = _resolveComponent("LocationIcon")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_TrailerModal = _resolveComponent("TrailerModal")
  const _component_ShareButton = _resolveComponent("ShareButton")
  const _component_ShareModal = _resolveComponent("ShareModal")
  const _component_EventCard = _resolveComponent("EventCard")
  const _component_SeeTheFullProgram = _resolveComponent("SeeTheFullProgram")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (!_ctx.event || _ctx.isFetchingEvents)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode(_component_LoadingIndicator, { class: "mx-auto py-32" })
            ]))
          : (_openBlock(), _createBlock("div", {
              key: _ctx.event?.id
            }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: "relative fill-event-background-image",
                  style: {
            marginTop: `calc(-1 * var(--header-height))`,
          }
                }, [
                  (_ctx.event?.imageCard)
                    ? (_openBlock(), _createBlock(_component_EventImage, {
                        key: 0,
                        path: _ctx.event.imageCard,
                        class: ["\n              absolute\n              inset-0\n              object-cover\n              w-full\n              h-full\n              transition\n              duration-200\n              ease-in-out\n            ", { 'opacity-0': !_ctx.showImage }],
                        loading: "lazy",
                        onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showImage = true))
                      }, null, 8, ["path", "class"]))
                    : _createCommentVNode("", true),
                  (_ctx.videoBackground)
                    ? (_openBlock(), _createBlock(_component_BackgroundVideo, {
                        key: 1,
                        class: "w-full h-full inset-0 absolute object-cover",
                        src: _ctx.videoBackground,
                        imagePoster: _ctx.event.imageCard || null
                      }, null, 8, ["src", "imagePoster"]))
                    : _createCommentVNode("", true),
                  _hoisted_3,
                  _hoisted_4
                ], 4)
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", {
                  class: "relative max-w-container px-container",
                  style: {
            paddingTop: `calc( -1 * var(--header-height))`,
          }
                }, [
                  (_ctx.event)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        (_ctx.eventTypeLabel)
                          ? (_openBlock(), _createBlock("div", _hoisted_7, [
                              _createVNode(_component_Label, { color: "amff-black" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.eventTypeLabel)), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.event.getDayFormatted("long", _ctx.currentLang)) + " " + _toDisplayString(_ctx.event.hour) + "h ", 1),
                        (_ctx.event.location)
                          ? (_openBlock(), _createBlock("a", {
                              key: 1,
                              href: _ctx.event.location.link,
                              target: "_blank",
                              class: "text-sm font-display rounded mb-6 inline-flex items-center"
                            }, [
                              _createVNode(_component_LocationIcon, {
                                fill: "currentColor",
                                class: "mr-1 w-5 h-5"
                              }),
                              _createTextVNode(_toDisplayString(_ctx.event.location.name), 1)
                            ], 8, ["href"]))
                          : _createCommentVNode("", true),
                        (_ctx.event.type === 'projection' && _ctx.event.section)
                          ? (_openBlock(), _createBlock("div", _hoisted_9, [
                              _createVNode(_component_Label, { color: "amff-pink" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.event.section.title), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_PageTitle, { class: "mb-6" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.event.title), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.event.media)
                          ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.event.media.directorNames.join(", ")), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_11, [
                          _createVNode(_component_Label, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.event.subtitle), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.event.media)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.event.media.genreNames, (genre) => {
                                return (_openBlock(), _createBlock(_component_Label, {
                                  color: "amff-black",
                                  class: "mr-2",
                                  key: genre
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(genre), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_12, [
                          (_ctx.event.media)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.event.media.year) + " · " + _toDisplayString(_ctx.event.media.getDurationFormatted(_ctx.currentLang)) + " · " + _toDisplayString(_ctx.event.media.countryNames.join(", ")), 1)
                              ], 64))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.event.getDurationFormatted(_ctx.currentLang)), 1)
                              ], 64))
                        ]),
                        _createVNode("div", _hoisted_13, [
                          _createVNode("div", null, [
                            (_ctx.event.accessLink)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  color: "amff-pink",
                                  class: "mb-6 mr-6 md:mb-0 bg-amff-teal",
                                  href: _ctx.event.accessLink,
                                  as: _ctx.AnchorLink
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.event.accessType === 'full')
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t("events.full_capacity")), 1)
                                        ], 64))
                                      : (_ctx.event.accessType === 'purchase')
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("events.buy_tickets")) + " ", 1),
                                            _createVNode(_component_ArrowIcon, {
                                              fill: "currentColor",
                                              class: "ml-2 w-4 h-4"
                                            })
                                          ], 64))
                                        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("events.book_tickets")) + " ", 1),
                                            _createVNode(_component_ArrowIcon, {
                                              fill: "currentColor",
                                              class: "ml-2 w-4 h-4"
                                            })
                                          ], 64))
                                  ]),
                                  _: 1
                                }, 8, ["href", "as"]))
                              : _createCommentVNode("", true),
                            (_ctx.event.type === 'conference' && _ctx.event.projectionSlug)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  as: _ctx.AnchorLink,
                                  to: {
                    name: 'event',
                    params: { type: 'projection', slug: _ctx.event.projectionSlug },
                  },
                                  color: "amff-pink-outline",
                                  class: "mb-6 md:mb-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("events.see_movie")) + " ", 1),
                                    _createVNode(_component_ArrowIcon, {
                                      fill: "currentColor",
                                      class: "ml-2 w-4 h-4"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["as", "to"]))
                              : _createCommentVNode("", true),
                            (
                    _ctx.event.type === 'projection' && _ctx.event?.media.videoTrailer
                  )
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 2,
                                  color: "amff-pink-outline",
                                  class: "mb-6 md:mb-0",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isTrailerModalOpen = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("home.play_trailer")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isTrailerModalOpen && _ctx.event.media.videoTrailer)
                              ? (_openBlock(), _createBlock(_component_TrailerModal, {
                                  key: 3,
                                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isTrailerModalOpen = false)),
                                  src: _ctx.event.media.videoTrailer
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_ShareButton, {
                            class: "pl-0 md:pl-2",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShareModalOpen = true))
                          }),
                          (_ctx.isShareModalOpen)
                            ? (_openBlock(), _createBlock(_component_ShareModal, {
                                key: 0,
                                isShareModalOpen: _ctx.isShareModalOpen,
                                "onUpdate:isShareModalOpen": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShareModalOpen = $event)),
                                title: _ctx.event.title,
                                image: _ctx.cdn(_ctx.event.media.imageCard, '375x0')
                              }, null, 8, ["isShareModalOpen", "title", "image"]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.event.type === 'projection')
                          ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("events.about_movie")), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("div", _hoisted_16, [
                            _createVNode("span", {
                              innerHTML: _ctx.event.description
                            }, null, 8, ["innerHTML"])
                          ]),
                          (_ctx.event.media)
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode("div", _hoisted_18, [
                                  (_ctx.event.media.originalTitle)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("events.original_title")) + ": ", 1),
                                        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.event.media.originalTitle), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("events.tags")) + ": ", 1),
                                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.event.media.tagNames.join(", ")), 1)
                                ]),
                                (_ctx.event.media.actorNames.length)
                                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("events.staff")) + ": ", 1),
                                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.event.media.actorNames.join(", ")), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 4),
                _hoisted_26,
                (_ctx.sameDayEvents.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_27, [
                      (_ctx.sameDayEvents.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_28, [
                            _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("events.the_same_day")), 1),
                            _createVNode("div", _hoisted_30, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sameDayEvents, (event) => {
                                return (_openBlock(), _createBlock(_component_EventCard, {
                                  key: 'event' + event.id,
                                  event: event
                                }, null, 8, ["event"]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.sameTypeEvents.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      (_ctx.sameTypeEvents.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_32, [
                            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("events.others_" + _ctx.event?.type)), 1),
                            _createVNode("div", _hoisted_34, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sameTypeEvents, (event) => {
                                return (_openBlock(), _createBlock(_component_EventCard, {
                                  key: 'event' + event.id,
                                  event: event
                                }, null, 8, ["event"]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SeeTheFullProgram, { class: "relative" })
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival, { class: "relative" })
  ], 64))
}